module.exports = __webpack_public_path__ + "static/media/2020-promo.5547c6c0.jpg";